<template>
  <el-card style="height: 100%" shadow="always" v-loading="loading">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center justify-content-between">
        <h3 class="text-navy">Contacts</h3>
        <el-button class="btn-primary text-uppercase" @click="showModal()">Add</el-button>
      </div>
      <div class="col-12" v-loading="loading">
        <el-table class="w-100" :data="guarantors">
          <el-table-column prop="full_name" label="Name" width="200" />
          <el-table-column prop="email" label="Email">
            <template slot-scope="scope">
              <a :href="`mailto:${scope.row.email}`" :title="scope.row.email" v-if="scope.row.email">
                <i class="fa fa-envelope fa-lg text-cloud-grey"></i>
              </a>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="Phone">
            <template slot-scope="scope">
              <a :href="`tel:${scope.row.phone}`" :title="scope.row.phone" v-if="scope.row.phone">
                <i class="fa fa-phone fa-lg text-cloud-grey"></i>
              </a>
            </template>
          </el-table-column>
          <el-table-column label="" v-if="!isProducer" align="right">
            <template slot-scope="scope">
              <el-button class="btn-secondary" @click="showModal(scope.row)">Edit</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <business-guarantor-modal :initial_business="business" v-if="formModalShow && !isProducer"
      @close="formModalShow = false" @getData="getData" :initial_guarantor="selectedGuarantor" />
  </el-card>
</template>
<script>
import Guarantor from "../../../modelsPortal/Guarantor";
import Business from "../../../modelsPortal/Business";
export default {
  props: {
    initial_business: {
      type: Object
    },
    isProducer: {
      type: Number
    }
  },
  data() {
    return {
      business: this.initial_business,
      guarantors: [],
      loading: false,
      formModalShow: false,
      selectedGuarantor: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;

      let guarantors = new Guarantor().for(new Business(this.business))
        .select('id', 'email', 'phone', 'is_primary_signatory', 'is_signatory', 'first_name', 'last_name', 'date_of_birth')
        .append('full_name')
        .params({ 'no_paginate': true })
        .orderBy("-id");

      guarantors
        .get()
        .then((res) => {
          this.loading = false;
          this.guarantors = res;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showModal(guarantor = null) {
      this.selectedGuarantor = guarantor
      this.formModalShow = true
    }
  }
};
</script>